import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=a268c2e4&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"
import style0 from "./ProfilePanel.vue?vue&type=style&index=0&id=a268c2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268c2e4",
  null
  
)

export default component.exports